/**
* @name APP ClassPanel
* @autor jaime.salazar@u-planner.com
* @description
* # name controller --> dialogSummaryControllers
* # As Controller --> dialogSummary
* brief comment controller for show dialog finish approval
                                                        
*/
import details from './detallePerfilDocente.json';

export default class dialogdetailcontroller{

	constructor($scope,	$http,$resource,$filter,ngNotify,$mdDialog, data, perfilSrv){
        this.$mdDialog = $mdDialog;
        this.ngNotify = ngNotify;
        this.perfilSrv = perfilSrv;
        this.params = data;
        this.details = [];
        this.main();
    }

    main() {
        let params = {
            param1: this.params.user.teacherId, 
            param2: this.params.row.Asignatura, 
            param3: this.params.row.Periodo, 
        }
        this.perfilSrv.list.getDetailPerfilDocente(params).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {

                let dataArray = [];

                for(var i = 0; i < response.data.length; i++){
                    
                    let obj = response.data[i];
                    let groupId = obj.dsGroup;
                    let groupData = { aspect: obj.aspect, avgAspect: obj.nmAspectAvg };
                    let dataObj = { id: groupId , data: [] };

                    let existantObject = dataArray.filter((obj)=>{return obj.id == groupId});
                    if(existantObject.length === 0){
                        dataObj.data.push(groupData);
                        dataArray.push(dataObj);
                    }
                    else{
                        existantObject[0].data.push(groupData)
                    }
                }
                this.details = dataArray;
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    close(){
        this.$mdDialog.hide();
    }
}

dialogdetailcontroller.$inject = ['$scope',
                            '$http',
                            '$resource',
                            '$filter',
                            'ngNotify',
                            '$mdDialog',
                            'data',
                            'perfilSrv'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_docente/dialog/dialogdetailcontroller.js